import React, { useState, useEffect } from "react";
import { Button } from "flowbite-react";
import MaterialListSelect from "./MaterialListSelect";
import PrintRequestPage from "./PrintRequestPage";
import axios from "axios";
import { useSelector } from "react-redux";
import { TbTrashX } from "react-icons/tb";
import { v4 as uuid } from "uuid";
import { toast } from "react-toastify";
import LoadingOverlay from "./LoadingOverlay";
import ConfirmDialog from "./ConfirmDialog";

function RequestMaterial() {
  const [selectedMatList, setSelectedMatList] = useState(null);
  const [selectedMatListName, setSelectedMatListName] = useState("");
  const [stockQty, setStockQty] = useState("");
  const [remark, setRemark] = useState("");
  const [transFor, setTransFor] = useState("");
  const { user } = useSelector((state) => state.auth);
  const [tempArray, setTempArray] = useState([]);
  const [currStock, setCurrStock] = useState(null);
  const [resetKey, setResetKey] = useState(0);
  const [shouldPrint, setShouldPrint] = useState(false);
  const [printGroupId, setPrintGroupId] = useState("");
  const [printItems, setPrintItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);
  const [printFormNo, setPrintFormNo] = useState(null); // running number from DB

  useEffect(() => {
    if (shouldPrint) {
      const timer = setTimeout(() => setShouldPrint(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [shouldPrint]);

  const handleMatListChange = (Arr) => {
    setSelectedMatList(Arr[0]);
    setSelectedMatListName(Arr[1]);
    setStockQty("");
    getCurrentStock(Arr[0]);
  };

  function applyStripedStyle(index) {
    return index % 2 === 0 ? "border-b bg-gray-50" : " bg-white"; // Apply the striped-row class to even-indexed rows
  }

  const handleStockInQTYInputChange = (e) => {
    const input = e.target.value;
    const regex = /^[0-9\b]+$/; // Regex to allow only numbers

    if (input === "" || regex.test(input)) {
      setStockQty(input);
    }
  };

  const handleRemarkInputChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    setRemark(uppercaseValue);
  };

  const handleCustomerInputChange = (e) => {
    const uppercaseValue = e.target.value.toUpperCase();
    setTransFor(uppercaseValue);
  };

  const addObject = () => {
    if (!stockQty || !selectedMatList || !selectedMatListName) {
      toast.warning("Please fill in all required fields");
      return;
    }

    const requestedQty = Number(stockQty);
    if (requestedQty > (currStock.current_stock || 0)) {
      toast.warning(
        "JUMLAH REQUEST BARANG MELEBIHI STOCK YANG ADA, SILAHKAN COBA LAGI"
      );
      setStockQty("");
      return;
    }

    const newObject = {
      no: 0, // We'll reassign numbers below
      product_id: selectedMatList,
      product_name: selectedMatListName,
      temp_qty: stockQty,
      stock_in: 0,
      stock_out: stockQty,
      transaction_type: "Pending",
      transaction_for: transFor,
      transaction_by: user.username,
      transaction_remark: remark,
    };

    // Filter out any existing entry for this product_id
    const updatedArray = tempArray.filter(
      (item) => item.product_id !== selectedMatList
    );

    // Add the new object
    updatedArray.push(newObject);

    // Reassign the `no` field
    const reindexed = updatedArray.map((item, index) => ({
      ...item,
      no: index + 1,
    }));

    setTempArray(reindexed);
    setStockQty("");
  };

  const createFormHeader = async () => {
    try {
      const res = await axios.post(
        "https://eps.elkomprintama.com/post/api/store/request_header"
      );
      return res.data.form_id; // running number from DB
    } catch (err) {
      console.error("Error creating form header:", err);
      toast.error("Failed to create form header");
      throw err;
    }
  };

  const deleteObject = (idToRemove) => {
    setTempArray(tempArray.filter((item) => item.no !== idToRemove));
  };

  const insertStock = async (data) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `https://eps.elkomprintama.com/post/api/store/stocks`,
        { transactions: data } // <- use the passed data
      );
      if (response.status === 200) {
        toast.success(response.data.msg);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getCurrentStock = async (product_id) => {
    if (!product_id) {
      setCurrStock(null);
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get(
        `https://eps.elkomprintama.com/get/api/store/currentallstock/${product_id}`
      );
      if (response.status === 200) {
        // Access the 'msg' property from the response data
        setCurrStock(response.data.result); // This will display the success message
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (tempArray.length === 0) {
      toast.warning("Please add data");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <>
      <div
        className={`w-full  rounded-lg bg-orange-500
        }`}
      >
        <label
          className={`block uppercase text-white  mb-2 tracking-wide  text-5xl text-center  font-bold `}
        >
          Request Material
        </label>
      </div>
      <div
        className={`relative h-full  bg-gray-100 overflow-x-auto shadow-md px-5 rounded-lg `}
      >
        <form className="my-5" onSubmit={handleSubmit}>
          <MaterialListSelect
            key={resetKey} // This forces re-render on key change
            onChangeList={handleMatListChange}
            location_id={3}
          ></MaterialListSelect>
          <div className="control w-full  ">
            <div className="flex flex-wrap -mx-3 mb-5">
              <div className="w-full md:w-1/2  px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor={`qty_request`}
                >
                  QTY
                </label>
                <input
                  className="appearance-none block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id={`qty_request`}
                  type="text"
                  placeholder="QTY"
                  value={stockQty}
                  onChange={handleStockInQTYInputChange}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="qty_stock_in"
                >
                  Sisa
                </label>

                <input
                  className={`appearance-none block w-full border bg-white border-gray-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white ${
                    currStock && currStock.current_stock === 0
                      ? "text-red-500"
                      : ""
                  }`}
                  id="qty_stock_in"
                  type="text"
                  placeholder="QTY"
                  disabled
                  readOnly
                  value={`${
                    currStock
                      ? `${currStock.current_stock} ${currStock.unit}`
                      : ""
                  }`}
                />
              </div>
            </div>
          </div>
          <div className="control w-full  ">
            <div className="flex flex-wrap -mx-3 mb-5">
              <div className="w-full px-3 ">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="stock_in_remark"
                >
                  CATATAN
                </label>
                <input
                  className="appearance-none uppercase block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id="stock_in_remark"
                  type="text"
                  placeholder="Catatan"
                  value={remark}
                  onChange={handleRemarkInputChange}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-5">
              <div className="w-full px-3 ">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="stock_in_remark"
                >
                  CUSTOMER
                </label>
                <input
                  className="appearance-none uppercase block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id="stock_in_customer"
                  type="text"
                  placeholder="Customer"
                  value={transFor}
                  onChange={handleCustomerInputChange}
                />
              </div>
            </div>
          </div>
          <div className="w-full ">
            <Button color="gray" fullSized onClick={addObject}>
              ADD
            </Button>
          </div>
          <div className="relative overflow-x-auto shadow-md my-6 sm:rounded-lg">
            <table className="text-sm text-left table-auto text-gray-500 dark:text-gray-400 w-full border-collapse">
              <thead className="sticky top-0 text-xs text-white uppercase bg-gray-600 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 py-5 flex-1 border-r"
                  >
                    No
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Product ID
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Product Name
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    QTY
                  </th>

                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Remark
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Customer
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1 border-r"
                  >
                    Input By
                  </th>
                  <th
                    scope="col"
                    className="whitespace-nowrap px-5 flex-1"
                  ></th>
                </tr>
              </thead>
              <tbody>
                {tempArray.map((data, index) => (
                  <tr
                    className={`py-6 text-xs border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ${applyStripedStyle(
                      index
                    )}`}
                    key={data.no}
                  >
                    <td className="whitespace-nowrap px-5 py-5 flex-1 border-r">
                      {data.no}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.product_id}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.product_name}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.temp_qty}
                    </td>

                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.transaction_remark}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.transaction_for}
                    </td>
                    <td className="whitespace-nowrap px-5 flex-1 border-r">
                      {data.transaction_by}
                    </td>
                    <td className="whitespace-nowrap px-2 py-3">
                      <button
                        className="font-medium text-red-500 dark:text-red-500 hover:underline px-3"
                        onClick={(e) => {
                          e.preventDefault();
                          deleteObject(data.no);
                        }}
                      >
                        <TbTrashX size={"1.5em"} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {tempArray.length > 0 && (
              <Button className="my-5" fullSized type="submit">
                Insert Data
              </Button>
            )}
          </div>
        </form>
      </div>
      {isLoading && <LoadingOverlay message="loading..." />}
      {showConfirm && uploadPending && (
        <ConfirmDialog
          message="Are you sure you want to insert the data?"
          onConfirm={async () => {
            setShowConfirm(false);
            try {
              // 1) Get running number from DB
              const formId = await createFormHeader();

              // 2) Generate UUID (keep using it as before)
              const groupId = uuid();

              // 3) Attach both IDs to each line
              const updatedArray = tempArray.map((item) => ({
                ...item,
                transaction_group_id: groupId, // UUID (old behavior retained)
                form_id: formId, // NEW running number
              }));

              // 4) Submit details
              await insertStock(updatedArray);

              // 5) Trigger Print with BOTH identifiers
              setPrintFormNo(formId); // running number
              setPrintGroupId(groupId); // UUID
              setPrintItems(updatedArray);
              setShouldPrint(true);

              // 6) Reset UI
              setRemark("");
              setStockQty("");
              setTempArray([]);
              setTransFor("");
              setResetKey((prev) => prev + 1);
            } catch (err) {
              console.error(err);
            } finally {
              setUploadPending(false);
            }
          }}
          onCancel={() => {
            setShowConfirm(false);
            setUploadPending(false);
          }}
        />
      )}
      {shouldPrint && (
        <PrintRequestPage
          formId={printFormNo}
          groupId={printGroupId}
          items={printItems}
          onDone={() => setShouldPrint(false)}
          useNow={true} // ✅ Use current time for new requests
        />
      )}
    </>
  );
}

export default RequestMaterial;
